import { Model } from 'app/model/backendmodel';
import { DatasetAdapter } from 'app/model/adapters/datasets/dataset.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import _ from 'lodash';
import { Metamodel } from 'app/model/base/model';
import { Dataset } from 'app/model/dataset/dataset';
import { ModelFetchUtils } from 'app/model/services/model.utils/model.fetch.utils';

export class GenericDatasetAdapter extends DatasetAdapter<Dataset, Model.DatasetResource> {
    protected async _toResource(dataset: Dataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetResource;
        const modelDataset = this.properties(modelDatasetResource) as Model.Dataset;
        const metaModel = Metamodel.modelOf(dataset);
        modelDataset.type = metaModel.tag('subType') || metaModel.name;
        modelDataset.structure = this.columnValueToResource(dataset, dataset.columns);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (modelDataset as any).typeProperties = {};

        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }

        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: Dataset): Promise<Dataset> {
        const typeModel = ModelFetchUtils.getModelByResourceType('dataset', modelDatasetResource.properties.type);
        if (!dataset) {
            dataset = typeModel.create(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        if (!dataset) {
            throw new Error('Not reachable code');
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const model = modelDatasetResource.properties as any;
        if (model) {
            dataset.columns = this.columnResourceToValue(dataset, model.structure);
        }

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, typeModel));

        return dataset;
    }
}
